// extracted by mini-css-extract-plugin
export default {"unFavoritedIcon":"favorite-menu-option-module__unFavoritedIcon___jV4Zc"};